var _path, _path2, _circle, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransactions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M403.155 413.151C403.407 413.414 403.825 413.423 404.088 413.17C404.352 412.918 404.361 412.5 404.108 412.237L403.155 413.151ZM361.141 369.309L403.155 413.151L404.108 412.237L362.094 368.396L361.141 369.309Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51C83 32.7746 97.7746 18 116 18H293C359.826 18 414 72.1736 414 139V466H116C97.7746 466 83 451.225 83 433V51Z",
    fill: "#231942"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 335.161,
    cy: 362.934,
    r: 130.05,
    fill: "white",
    stroke: "#0060DC",
    strokeWidth: 2.90884
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.391 102.411H236.31",
    stroke: "white",
    strokeWidth: 29,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141.406 172.197H236.326",
    stroke: "white",
    strokeWidth: 29,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M283.156 294.987H387.727V308.348H348.27C348.27 308.348 360.815 322.245 360.815 331.332H387.612V343.623H361.954C361.954 343.623 356.822 385.098 307.673 382.533L367.657 450.198H343.71L283.156 384.886V371.203C283.156 371.203 312.92 372.057 327.174 362.972C338.691 355.597 337.209 351.107 338.235 346.83C338.578 345.227 337.322 343.731 335.611 343.731H283.156V331.438H336.867C338.006 331.438 338.691 330.368 338.122 329.407C335.839 325.238 329.797 315.938 321.473 314.228C310.638 312.091 283.156 311.555 283.156 311.555V294.987Z",
    fill: "#231942"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactions);
export default __webpack_public_path__ + "static/media/transactions.81e8f4bb69f533b52c88ffa47185a38c.svg";
export { ForwardRef as ReactComponent };